// Australian DD/MM/YYYY display ↔ ISO YYYY-MM-DD storage. Pure string/local-date maths — never UTC, so no day shift.
const pad = (n) => String(n).padStart(2, "0");

export function isValidYmd(y, m, d) {
  if (!(y >= 1900 && y <= 2999 && m >= 1 && m <= 12 && d >= 1)) return false;
  return d <= new Date(y, m, 0).getDate();
}

export function isoToAu(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  return m ? `${m[3]}/${m[2]}/${m[1]}` : "";
}

export function auToIso(au) {
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec((au || "").trim());
  if (!m) return null;
  const [d, mo, y] = [Number(m[1]), Number(m[2]), Number(m[3])];
  return isValidYmd(y, mo, d) ? `${y}-${pad(mo)}-${pad(d)}` : null;
}

export const localDateToIso = (dt) => `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;

export function isoToLocalDate(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : undefined;
}

// Auto-insert slashes while typing digits: 0103 → 01/03, 01032026 → 01/03/2026
export function maskAu(raw) {
  const digits = (raw || "").replace(/\D/g, "").slice(0, 8);
  return [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter(Boolean).join("/");
}
